// Map of currency codes to phone codes - updated to include more countries
const currencyToPhoneCode: Record<string, string> = {
  'AUD': '+61', // Australia
  'PHP': '+63', // Philippines
  'USD': '+1',  // United States
  'GBP': '+44', // United Kingdom
  'NZD': '+64', // New Zealand
  'SGD': '+65', // Singapore
  'MYR': '+60', // Malaysia
  'THB': '+66', // Thailand
  'EUR': '+49', // Default to Germany for EUR (could be many EU countries)
  'CAD': '+1',  // Canada
  'JPY': '+81', // Japan
  'CNY': '+86', // China
  'KRW': '+82', // South Korea
  'INR': '+91', // India
  'HKD': '+852', // Hong Kong
  'TWD': '+886', // Taiwan
  'ZAR': '+27', // South Africa
  'BRL': '+55', // Brazil
  'MXN': '+52', // Mexico
  'ARS': '+54', // Argentina
  'CLP': '+56', // Chile
  'COP': '+57', // Colombia
  'PEN': '+51', // Peru
  'VND': '+84', // Vietnam
  'IDR': '+62', // Indonesia
  'TRY': '+90', // Turkey
  'RUB': '+7',  // Russia
  'UAH': '+380', // Ukraine
  'PLN': '+48', // Poland
  'CZK': '+420', // Czech Republic
  'HUF': '+36', // Hungary
  'RON': '+40', // Romania
  'BGN': '+359', // Bulgaria
  'HRK': '+385', // Croatia
  'SAR': '+966', // Saudi Arabia
  'AED': '+971', // UAE
  'QAR': '+974', // Qatar
  'KWD': '+965', // Kuwait
  'BHD': '+973', // Bahrain
  'OMR': '+968', // Oman
  'JOD': '+962', // Jordan
  'LBP': '+961', // Lebanon
  'EGP': '+20',  // Egypt
  'MAD': '+212', // Morocco
  'TND': '+216', // Tunisia
  'DZD': '+213', // Algeria
  'LYD': '+218', // Libya
  'NGN': '+234', // Nigeria
  'GHS': '+233', // Ghana
  'KES': '+254', // Kenya
  'UGX': '+256', // Uganda
  'TZS': '+255', // Tanzania
  'ZWL': '+263', // Zimbabwe
  'ZMW': '+260', // Zambia
  'BWP': '+267', // Botswana
  'SZL': '+268', // Swaziland
  'LSL': '+266', // Lesotho
  'NAD': '+264', // Namibia
  'MUR': '+230', // Mauritius
  'SCR': '+248', // Seychelles
  'MVR': '+960', // Maldives
  'LKR': '+94',  // Sri Lanka
  'NPR': '+977', // Nepal
  'BTN': '+975', // Bhutan
  'BDT': '+880', // Bangladesh
  'PKR': '+92',  // Pakistan
  'AFN': '+93',  // Afghanistan
  'IRR': '+98',  // Iran
  'IQD': '+964', // Iraq
  'SYP': '+963', // Syria
  'JEP': '+44',  // Jersey (uses GBP equivalent)
  'GGP': '+44',  // Guernsey (uses GBP equivalent)
  'IMP': '+44',  // Isle of Man (uses GBP equivalent)
};

export const getPhoneCodeFromCurrency = (currency: string): string => {
  return currencyToPhoneCode[currency.toUpperCase()] || '+61'; // Default to AU
};